import ShareIcon from './ShareIcon'

export default ShareIcon
